@if (!editMode) {
  @if (table.matrixTable; as mt) {
    @if (hasRowAndColumnInputs) {
      @for (warning of lookupDriftWarnings; track warning) {
        <p class="matrix-lookup-drift-warning" role="status">{{ warning }}</p>
      }
      <table class="table matrix-readonly" style="width: auto">
        <thead>
          <tr>
            <th scope="col" class="matrix-corner" aria-hidden="true"></th>
            @for (colIndex of columnIndices(mt); track colIndex) {
              <th scope="col" [attr.id]="columnHeaderId(colIndex)">{{ bandHeaderLabel(mt.columns, colIndex) }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (rowIndex of rowIndices(mt); track rowIndex) {
            <tr>
              <th scope="row" [attr.id]="rowHeaderId(rowIndex)">{{ bandHeaderLabel(mt.rows, rowIndex) }}</th>
              @for (colIndex of columnIndices(mt); track colIndex) {
                <td>{{ mt.values[cellIndex(mt, rowIndex, colIndex)] | number }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p class="table-placeholder-no-grid">This matrix does not have row and column inputs configured yet.</p>
    }
  }
} @else {
  @if (table.matrixTable; as mtEdit) {
    @if (isEditingRowColumnInputs) {
      <mat-card-content>
        <p class="matrix-edit-step-hint">
          Set row and column inputs and breakpoints here. Cell values are not edited until you apply; the matrix grid below then shows bands in the headers.
        </p>
        <app-matrix-axis-input title="Rows" [axis]="mtEdit.rows" [hideInputSelectors]="false" (axisStructureChange)="onAxisBandsOrInputChanged()" />
        <app-matrix-axis-input title="Columns" [axis]="mtEdit.columns" [hideInputSelectors]="false" (axisStructureChange)="onAxisBandsOrInputChanged()" />
        <div class="matrix-input-actions">
          <button mat-stroked-button color="primary" type="button" (click)="applyRowColumnInputs()" [disabled]="!hasRowAndColumnInputs">Apply row & column inputs</button>
          <button mat-stroked-button color="warn" type="button" class="matrix-action-gap" (click)="cancelRowColumnInputEdit()">Cancel input changes</button>
        </div>
      </mat-card-content>
    }
    @if (!hasRowAndColumnInputs && !isEditingRowColumnInputs) {
      <mat-card-content>
        <p class="table-placeholder-edit">Choose row and column inputs for this matrix. When you apply, you can edit bands and cell values.</p>
        <button mat-stroked-button color="primary" type="button" (click)="beginRowColumnInputEdit()">Set row & column inputs</button>
      </mat-card-content>
    }
    @if (hasRowAndColumnInputs && !isEditingRowColumnInputs) {
      <mat-card-content>
        <div class="input-label matrix-axis-readonly">
          <div><strong>Rows</strong> <span class="matrix-axis-summary-gap">{{ axisSummary(mtEdit.rows) }}</span></div>
          <div><strong>Columns</strong> <span class="matrix-axis-summary-gap">{{ axisSummary(mtEdit.columns) }}</span></div>
          <button mat-stroked-button color="primary" type="button" (click)="beginRowColumnInputEdit()">Change row & column inputs</button>
        </div>
        @for (warning of lookupDriftWarnings; track warning) {
          <p class="matrix-lookup-drift-warning" role="status">{{ warning }}</p>
        }
        <ng-container *ngTemplateOutlet="matrixValueGrid; context: { mt: mtEdit }"></ng-container>
      </mat-card-content>
    }
    <ng-template #matrixValueGrid let-mt="mt">
      <span id="matrix-value-cells-legend" class="cdk-visually-hidden">Matrix cell values</span>
      <table class="table matrix-edit" style="width: auto" aria-describedby="matrix-value-cells-legend">
        <thead>
          <tr>
            <th scope="col" class="matrix-corner" aria-hidden="true"></th>
            @for (colIndex of columnIndices(mt); track colIndex) {
              <th scope="col" [attr.id]="columnHeaderId(colIndex)">{{ bandHeaderLabel(mt.columns, colIndex) }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (rowIndex of rowIndices(mt); track rowIndex) {
            <tr>
              <th scope="row" [attr.id]="rowHeaderId(rowIndex)">{{ bandHeaderLabel(mt.rows, rowIndex) }}</th>
              @for (colIndex of columnIndices(mt); track colIndex) {
                <td>
                  <mat-form-field appearance="outline" class="matrix-cell-field">
                    <mat-label>Cell value</mat-label>
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="mt.values[cellIndex(mt, rowIndex, colIndex)]"
                      [attr.aria-labelledby]="columnHeaderId(colIndex) + ' ' + rowHeaderId(rowIndex)"
                      />
                  </mat-form-field>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </ng-template>
  }
}
